import { useState } from "react"
import type { Sessione } from "./api/tipi"
import { Accedi, Invito, NuovaPassword } from "./schermate/Accesso"
import { Regia } from "./schermate/Regia"
import { Serata } from "./schermate/Serata"
import { dimenticaSessione, leggiSessione, salvaSessione } from "./stato/sessione"

type Percorso =
  | { tipo: "regia" }
  | { tipo: "invito"; codice: string }
  | { tipo: "reset"; codice: string }
  | { tipo: "radice" }

/** Le schermate si scelgono dal percorso, senza router: la regia su /regia,
 *  i due link che arrivano su WhatsApp (/entra/…, /reset/…) e la radice. */
function leggiPercorso(): Percorso {
  const percorso = location.pathname.replace(/\/$/, "")
  if (percorso === "/regia") return { tipo: "regia" }
  const link = percorso.match(/^\/(entra|reset)\/([^/]+)$/)
  if (link) {
    try {
      const codice = decodeURIComponent(link[2])
      return link[1] === "entra" ? { tipo: "invito", codice } : { tipo: "reset", codice }
    } catch {
      // Un `%` malformato nel link manda in eccezione decodeURIComponent:
      // meglio la radice che una pagina bianca.
      return { tipo: "radice" }
    }
  }
  return { tipo: "radice" }
}

export function App() {
  const [percorso, setPercorso] = useState(leggiPercorso)
  const [sessione, setSessione] = useState<Sessione | null>(leggiSessione)
  /** Perché si è tornati all'accesso, quando non l'ha deciso il giurato. */
  const [avviso, setAvviso] = useState<string | null>(null)

  if (percorso.tipo === "regia") return <Regia />

  // Il link non resta nella barra dell'indirizzo: ricaricare non deve
  // riusarlo, e un link di reset è già stato consumato.
  const allaRadice = () => {
    history.replaceState(null, "", "/")
    setPercorso({ tipo: "radice" })
  }

  const entrato = (s: Sessione) => {
    salvaSessione(s)
    setSessione(s)
    setAvviso(null)
    allaRadice()
  }

  if (percorso.tipo === "invito") return <Invito codice={percorso.codice} onEntrato={entrato} />
  if (percorso.tipo === "reset") {
    return <NuovaPassword codice={percorso.codice} onEntrato={entrato} onFatto={allaRadice} />
  }

  if (!sessione) return <Accedi avviso={avviso} onEntrato={entrato} />

  return (
    <Serata
      sessione={sessione}
      onEsci={(motivo?: string) => {
        dimenticaSessione(sessione.token)
        setSessione(null)
        // `onEsci` è anche un gestore di click diretto (il bottone "Esci" di
        // Serata lo passa a `onClick` senza un wrapper): `motivo` può quindi
        // essere l'evento del click invece di una stringa, e va scartato.
        setAvviso(typeof motivo === "string" ? motivo : null)
      }}
    />
  )
}
